<template>
  <div id="app2">
    <div class="main">
      <partner-header />
      <router-view />
      <partner-footer />
    </div>
  </div>
</template>

<script>
import PartnerFooter from './components/layout/PartnerFooter.vue'
import PartnerHeader from './components/layout/PartnerHeader.vue'

export default {
  name: 'App',
  components: {
    PartnerHeader,
    PartnerFooter,
  }
}
</script>

<style>
#app {
  font-family: "Lato", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: #fafafa;
  float: left;
}
.main {
  background-color: #ffffff;
  width: 100%;
  margin: 0;
  padding: 0;
}
.page {
  width: 100%;
  padding: 2% 5% 0 5%;
  min-height: 70vh;
}

@media only screen and (min-width: 745px) {
  .main {
    width: 70%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
  }
}
</style>
